import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const SECTIONS = [
  {
    title: "About these terms",
    body: "These terms govern the relationship between SourceWorld Automations ('we', 'us') and the businesses we work with ('you'). By engaging our services or requesting work through this website, you agree to these terms.",
  },
  {
    title: "Our services",
    body: "We provide website design and launch, Google Business Profile and local visibility support, social business setup, lead capture systems, business automation and local SEO services. The exact scope of each project is agreed in writing before work begins.",
  },
  {
    title: "Quotes and pricing",
    body: "Package prices shown on this website are a guide. Final pricing depends on your project requirements and is confirmed in a written quote before any work starts. A project begins once the quote is accepted and any agreed deposit is paid.",
  },
  {
    title: "Your responsibilities",
    body: "You agree to provide accurate business information, brand assets, content and timely feedback reasonably needed to complete your project, and to confirm you have the rights to any materials you supply to us.",
  },
  {
    title: "Intellectual property",
    body: "Once your project is paid for in full, ownership of the completed website and deliverables transfers to you. We may showcase non-confidential work in our portfolio unless you ask us not to.",
  },
  {
    title: "Ongoing support",
    body: "Optional monthly support plans cover website maintenance, content updates, SEO monitoring and automation support. Support plan terms, scope and pricing are agreed separately in writing.",
  },
  {
    title: "Liability",
    body: "We take great care in our work, but we cannot guarantee specific search rankings, enquiry volumes or business outcomes. To the extent permitted by law, our liability is limited to the fees paid for the services in question.",
  },
  {
    title: "Governing law",
    body: "These terms are governed by the laws of England and Wales, and any disputes are subject to the exclusive jurisdiction of the courts of England and Wales.",
  },
];

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <Seo
        title="Terms of Service — SourceWorld Automations"
        description="The terms that govern projects and services provided by SourceWorld Automations to UK local businesses."
      />
      <Navbar />
      <main className="pt-[72px]">
        <div className="section-shell py-16 sm:py-24 max-w-3xl">
          <p className="micro-label">Legal</p>
          <h1 className="mt-4 font-heading text-3xl sm:text-4xl font-black tracking-tight text-white">Terms of Service</h1>
          <p className="mt-3 font-mono text-xs uppercase tracking-[0.18em] text-slate-500">Last updated: July 2026</p>
          <div className="mt-10 space-y-8">
            {SECTIONS.map((s) => (
              <section key={s.title}>
                <h2 className="font-heading text-lg sm:text-xl font-bold text-white">{s.title}</h2>
                <p className="mt-2.5 text-sm sm:text-base leading-relaxed text-slate-400">{s.body}</p>
              </section>
            ))}
          </div>
          <Link to="/" data-testid="terms-back-home" className="btn-ghost mt-12">
            <ArrowLeft size={15} strokeWidth={2.5} /> Back to Homepage
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
